/**
 * 
 * https://freightlinertrucks-dev.azurewebsites.net/umbraco/Api/Asset/OrderByList
	- Get all order by items (I can also provide this on the Razor file rather than an api call)
	https://freightlinertrucks-dev.azurewebsites.net/umbraco/Api/Asset/AssetTypes
		- Get all asset types (I can also provide this on the Razor file rather than an api call)
	https://freightlinertrucks-dev.azurewebsites.net/umbraco/ResourceLibrary/Menu/Get
		- Get Categories (Topics) from the Root
	https://freightlinertrucks-dev.azurewebsites.net/umbraco/ResourceLibrary/Menu/Get?nodeId=1
		- Get Categories (Topics) from a specified Node
	https://freightlinertrucks-dev.azurewebsites.net/umbraco/Api/Asset/All?start=0&count=10&orderBy=FileDate&assetTypes=
		- Get all assets
	https://freightlinertrucks-dev.azurewebsites.net/umbraco/Api/Asset/All?start=0&count=10&orderBy=FileDate&assetTypes=IMG
		- Get all assets by Asset Type (IMG) assetTypes can be a csv
	https://freightlinertrucks-dev.azurewebsites.net/umbraco/Api/Asset/Get?start=0&count=10&orderBy=FileDate&nodeId=1&includeAll=false&assetTypes=&
		- Get all assets by node
		- includeAll (true,false) return all assets and assets under child nodes
	https://freightlinertrucks-dev.azurewebsites.net/umbraco/Api/Asset/Search?start=0&count=10&searchTerm=cascadia&
		- Search assets
 */

const API_BASE = "/umbraco";

const requestCache = {};

function objToQueryString(defaults = {}, options = {}) {
	return Object.entries({ ...defaults, ...options }).reduce(
		(acc, [key, val]) =>
			true
				? `${acc}&${encodeURIComponent(key)}=${encodeURIComponent(val)}`
				: acc,
		""
	);
}

function cacheResponse(requestURL, refreshCache) {
	if (requestCache[requestURL] && !refreshCache)
		return requestCache[requestURL];
	return (requestCache[requestURL] = fetch(requestURL).then((r) => r.json()));
}

export function getCopy(nodeId, refreshCache = false) {
	const requestURL = `${API_BASE}/api/resourcelibrary/copy/${nodeId}`;
	return cacheResponse(requestURL, refreshCache).then((copy) => copy || { footer: '' });
}

export function getMenu(id = 1, refreshCache = false) {
	return cacheResponse(
		`${API_BASE}/api/resourcelibrary/menu/` + id,
		refreshCache
	).then((d) => {
		return d?.children || [];
	});
}

export function getNode(id, refreshCache = false) {
	return cacheResponse(
		`${API_BASE}/api/resourcelibrary/menu/` + id,
		refreshCache
	).then((d) => {
		return d || {};
	});
}

export function getNodeId(category, refreshCache = false) {
	return cacheResponse(
		`${API_BASE}/api/resourcelibrary/nodeid/` + category,
		refreshCache
	).then((d) => {
		return d || 0;
	});
}

export function getAssetTypes(refreshCache = false) {
	return cacheResponse(`${API_BASE}/api/resourcelibrary/assets/assettypes`, refreshCache).then(
		(d) => d || []
	);
}

export function getOrderByTypes(refreshCache = false) {
	return cacheResponse(`${API_BASE}/api/resourcelibrary/assets/orderbylist`, refreshCache).then(
		(d) => d || []
	);
}

export function getAssets(nodeId, options = {}, refreshCache = false) {
	const defaults = {
		start: 0,
		count: 12,
		orderBy: "FileDate",
		includeAll: true,
		assetTypes: "",
	};
	const queryString = objToQueryString(defaults, options);
	const requestURL = `${API_BASE}/api/resourcelibrary/asset?nodeId=${nodeId}${queryString}`;
	return cacheResponse(requestURL, refreshCache).then((d) => d || {});
}

export function getSearch(term, options, refreshCache = false) {
	const defaults = {
		start: 0,
		count: 12,
	};
	const queryString = objToQueryString(defaults, options);
	const requestURL = `${API_BASE}/api/resourcelibrary/assets/search?searchTerm=${encodeURIComponent(
		term
	)}${queryString}`;

	return cacheResponse(requestURL, refreshCache).then((d) => d || []);
}
